import dom from '../utils/dom';
import IconSprites from '../utils/IconSprites';
import SvgIcon from '../utils/SvgIcon';

const attrIsBusy = 'data-tn-is-busy';

function applyBusyStyling($btn: HTMLButtonElement, { disableElement = true } = {}) {
  $btn.setAttribute(attrIsBusy, '');

  disableButton($btn, disableElement);

  const $icon = SvgIcon.getElement(IconSprites.ArrowRepeat, 'tn-waiting');

  $btn.appendChild($icon!);
}

function resetButtonStyling($btn: HTMLButtonElement) {
  $btn.removeAttribute(attrIsBusy);

  $btn.disabled = false;
  $btn.removeAttribute('aria-disabled');
  $btn.classList.remove('disabled');

  const $icon = dom.findFrom($btn, '.tn-waiting');

  if ($icon) {
    dom.remove($icon);
  }
}

function disableButton($btn: HTMLButtonElement, hardDisable = false) {
  if (hardDisable) {
    $btn.disabled = true;
  } else {
    $btn.setAttribute('aria-disabled', 'true');
    $btn.classList.add('disabled');
  }
}

function isButtonDisbaled($btn: HTMLButtonElement) {
  return $btn.disabled || $btn.classList.contains('disabled');
}

export default {
  applyBusyStyling,
  resetButtonStyling,
  disableButton,
  isButtonDisbaled,
};
